import React from 'react';

import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { AUTH_SECURITY_DEACTIVATE_ACCOUNT } from 'apps/auth/constants/UrlConstants';

import SecurityPopupMenu from './SecurityPopupMenu';

const SecurityRightMenu = (props) => {
    return (
        <DiskButton
            type="tagA"
            iconName="dots"
            href={AUTH_SECURITY_DEACTIVATE_ACCOUNT}
            onClick={(e) => {
                e.preventDefault();
                props.popupRef.current?.open(<SecurityPopupMenu popupRef={props.popupRef} />);
            }}
        />
    );
};

export default SecurityRightMenu;
